import React, { useState } from 'react';
import moment from 'moment-timezone';

import StandaloneCartHistorySkeleton from '../../../components/skeletons/standalone-cart-history-skeleton/standalone-cart-history-skeleton';
import StandaloneCartDetailsSideBar from '../standalone-cart-details-side-bar/standalone-cart-details-side-bar';
import StandaloneCartHistoryHeader from './components/standalone-cart-history-header';
import { FilledButton } from '../../../components';
import { StandaloneCartRow } from '../standalone-cart-row/standalone-cart-row';
import useStandaloneCartsListPagination from '../../../hooks/useStandaloneCartsListPagination';

import './standalone-cart-history.scss';

const groupCartsByDate = (carts) => {
      return carts.reduce((groups, cart) => {
            const createdAtMoment = moment
                  .unix(cart.createdAt.seconds)
                  .add(cart.createdAt.nanoseconds / 1e6, 'milliseconds');
            const dateKey = createdAtMoment.format('YYYY-MM-DD');

            if (!groups[dateKey]) {
                  groups[dateKey] = [];
            }
            groups[dateKey].push(cart);
            return groups;
      }, {});
};

const formatDateLabel = (dateStr) => {
      return moment(dateStr).tz(moment.tz.guess()).format('LL');
};

const StandaloneCartHistory = ({ onBack, onSelectItem, isSidebarOpened, onClose }) => {
      const { carts, loading, hasMore, loadMore, refetch } = useStandaloneCartsListPagination();
      const [selectedItem, setSelectedItem] = useState(null);

      if (!loading && (!carts || carts.length === 0)) {
            return (
                  <div className="standalone-cart-history-container">
                        <StandaloneCartHistoryHeader onPressBack={onBack} />

                        <div className="main-content-empty-container">
                              <div className="empty-container">
                                    No Cart Links has been created yet.
                              </div>
                        </div>
                  </div>
            )
      }

      const handleSelectItem = (cart) => {
            setSelectedItem(cart);

            if (onSelectItem) {
                  onSelectItem(cart);
            }
      };

      const groupedCarts = groupCartsByDate(carts);

      return (
            <div className="standalone-cart-history-container">
                  <StandaloneCartHistoryHeader onPressBack={onBack} />

                  <div className="main-content-container">
                        {Object.entries(groupedCarts).map(([date, cartsForDate]) => (
                              <div className="date-group" key={date}>
                                    <div className="date-divider">{formatDateLabel(date)}</div>
                                    {cartsForDate.map((cart) => (
                                          <StandaloneCartRow
                                                key={cart.cartId}
                                                cartItem={cart}
                                                onSelectItem={() => handleSelectItem(cart)}
                                                isSelected={selectedItem?.cartId === cart.cartId}
                                                onDeleted={refetch}
                                          />
                                    ))}
                              </div>
                        ))}

                        {loading && <StandaloneCartHistorySkeleton />}

                        {hasMore && (
                              <div className="btn-container">
                                    <FilledButton
                                          className="button"
                                          style={{ height: '44px', backgroundColor: `var(--main-color)` }}
                                          onClick={loadMore}
                                          disabled={loading}
                                    >
                                          Load More Carts
                                    </FilledButton>
                              </div>
                        )}
                  </div>

                  {isSidebarOpened && (
                        <StandaloneCartDetailsSideBar
                              sidebarAnimation={isSidebarOpened ? "show" : "close"}
                              onCloseStandaloneCartDetailsSidebar={onClose}
                              selectedItem={selectedItem}
                              paginationRefetch={refetch}
                        />
                  )}
            </div>
      )
}

export default StandaloneCartHistory;
